import { HTMLColor } from "../../../colors/HTMLColor";
import { ElementAttribute } from "../../../dom-tools/ElementAttribute";
import { ElementType } from "../../../dom-tools/ElementType";
import { Range } from "../../../geometry/Range";
import { MathX } from "../../../math/MathX";
import { TextFX } from "../TextFX";
import { TextFXElement } from "../TextFXElement";
import { TextFXLetter } from "../TextFXLetter";
import { TextFXModule, TextFXModuleSettings } from "../TextFXModule";

export class ColorFadingTextFXSettings extends TextFXModuleSettings
{
  color:HTMLColor[];
  byPosition:number;
  duration:Range;
  delay:Range;
}

export class ColorFadingTextFX extends TextFXModule
{
  static readonly elementType    = new ElementType( "text--fx-color-fading");

  static readonly color      = new ElementAttribute( "color" );
  static readonly byPosition = new ElementAttribute( "by-position" );
  static readonly duration   = new ElementAttribute( "duration" );
  static readonly delay      = new ElementAttribute( "delay" );

  get type() { return ColorFadingTextFX.elementType; }

  getSettings( element:Element )
  {
    let settings = new ColorFadingTextFXSettings();
    settings.module = this;
    
    settings.color       = ColorFadingTextFX.color.parseColors( element );
    settings.byPosition  = ColorFadingTextFX.byPosition.asNumberFrom( element );
    settings.duration    = ColorFadingTextFX.duration.asRange( element );
    settings.delay       = ColorFadingTextFX.delay.asRange( element );

    return settings;
  }

 
  apply( letter:TextFXLetter[], genericSettings:TextFXModuleSettings )
  {
    let fadingSettings = genericSettings as ColorFadingTextFXSettings;
    letter.forEach( l => this.#applyOnLetter( l,  fadingSettings ) );
  }

  
  #applyOnLetter( textLetter:TextFXLetter, settings:ColorFadingTextFXSettings )
  {    
    let element  = textLetter.element as HTMLElement;
    let position = textLetter.letterPosition;  

    let byPositionValue = settings.byPosition >= 0 ?  
                                MathX.lerp( 1, position, settings.byPosition ) :
                                MathX.lerp( position, 1, -settings.byPosition );
    
    let targetValue   = TextFX.random.lerpRGB( settings.color );
    let duration      = TextFX.random.in( settings.duration ) * byPositionValue;
    let delay         = TextFX.random.in( settings.delay ) * byPositionValue;
    
    textLetter.setTransition( "color", duration, delay );

    element.style.color = targetValue + "";

    //console.log( "Set color", settings.color, targetValue );
  }


}